<template>
  <div id="app">
    <div class="wrapper">
      <div
        v-if="this.$router.history.current.name != 'login'"
        class="sidebar"
        data-color="orange"
        data-image="assets/img/sidebar-5.jpg"
      >
        <Sidebar />
      </div>
      <div
        v-if="this.$router.history.current.name != 'login'"
        class="main-panel"
      >
        <Nav />

        <router-view />
      </div>

      <router-view v-else />
    </div>
  </div>
</template>

<script>
import Nav from './components/Nav'
import Sidebar from './components/Sidebar'

export default {
  components: {
    Nav,
    Sidebar
  },

  mounted() {}
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
